import { useMedia } from 'react-use'

// Tailwind-aligned breakpoints matching Tamagui v5 config defaults
const breakpoints = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1536,
} as const

type Breakpoint = keyof typeof breakpoints

export const useIsMobile = () => {
    return useMedia(`(max-width: ${breakpoints.sm}px)`)
}

export const isAboveBreakpoint = (breakpoint: Breakpoint) => {
    return useMedia(`(min-width: ${breakpoints[breakpoint]}px)`)
}

export const isBelowBreakpoint = (breakpoint: Breakpoint) => {
    return useMedia(`(max-width: ${breakpoints[breakpoint]}px)`)
}
